














import { Component, Prop, Vue } from "@zoovu/runner-browser-api";

@Component({})
export default class BaseSvg extends Vue {
  @Prop()
  name!: string;

  @Prop()
  width!: number;

  @Prop()
  height!: number;

  @Prop({ default: 0 })
  x!: number;

  @Prop({ default: 0 })
  y!: number;
}
